document.addEventListener('DOMContentLoaded', () => {
    const expandBtn = document.querySelector('[data-map-resize-big]');
    const shrinkBtn = document.querySelector('[data-map-resize-small]');
    const panelRight = document.querySelector('[data-map-panel-right]');
    const panelLeft = document.querySelector('[data-map-panel-left]');

    const toggleMapSize = (isExpanded) => {
        panelRight.classList.toggle('small-map', !isExpanded);
        panelLeft.classList.toggle('small-map', !isExpanded);
        expandBtn.classList.toggle('disabled', isExpanded);
        shrinkBtn.classList.toggle('disabled', !isExpanded);
    };

    expandBtn.addEventListener('click', () => toggleMapSize(true));
    shrinkBtn.addEventListener('click', () => toggleMapSize(false));
});
